import React, { useEffect, useState } from 'react';
import { useAppState } from '../../contexts/AppStateContext';
import { useUi } from '../../contexts/UiContext';
import { DEMO_DATE } from '../../data/families';
import { Sheet } from '../ui/Sheet';
import { Button } from '../ui/Button';
const inputCls = 'mt-1.5 h-11 w-full rounded-xl border border-line bg-surface px-3 text-sm focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/30';
export function ManualEntrySheet() {
  const {
    manualEntry,
    closeManualEntry
  } = useUi();
  const {
    myTemplates,
    addManualEntry
  } = useAppState();
  const [templateId, setTemplateId] = useState('');
  const [freeLabel, setFreeLabel] = useState('');
  const [minutesText, setMinutesText] = useState('');
  const [date, setDate] = useState(DEMO_DATE);
  useEffect(() => {
    if (manualEntry.open) {
      setTemplateId(manualEntry.templateId ?? '');
      setFreeLabel('');
      setMinutesText('');
      setDate(DEMO_DATE);
    }
  }, [manualEntry]);
  const minutes = Number.parseInt(minutesText, 10);
  const minutesValid = Number.isFinite(minutes) && minutes >= 1 && minutes <= 600;
  const activityValid = templateId !== '' || freeLabel.trim() !== '';
  const valid = minutesValid && activityValid && date !== '';
  return <Sheet open={manualEntry.open} onClose={closeManualEntry} title="Ročni vnos časa" subtitle="Za dejavnost, ki si jo opravil brez časovnika" footer={<Button className="w-full" size="lg" disabled={!valid} onClick={() => {
    addManualEntry({
      minutes,
      date,
      templateId: templateId || undefined,
      freeLabel: templateId ? undefined : freeLabel.trim()
    });
    closeManualEntry();
  }} data-id="element-331" data-mp="2w2bcoiqc9sn7">
          Shrani vnos
        </Button>} data-id="element-330" data-mp="352q1hs2ihpvg">
      <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-332" data-mp="fg0ixasfldet">
        <div data-id="element-333" data-mp="fdxswqra3ka3">
          <label htmlFor="manual-task" className="text-sm font-extrabold" data-id="element-334" data-mp="29vz7qod2lvdg">
            Dejavnost
          </label>
          <select id="manual-task" value={templateId} onChange={e => setTemplateId(e.target.value)} className={inputCls} data-id="element-335" data-mp="2en7hjlibbir5">
            <option value="" data-id="element-336" data-mp="1zyul6nfbbxw4">Prosta dejavnost</option>
            {myTemplates.map(t => <option key={t.id} value={t.id} data-id="element-337" data-mp="24xxp24jk3y2i">
                {t.title}
              </option>)}
          </select>
        </div>
        {templateId === '' && <div data-id="element-338" data-mp="2xlbgxo8ee3fr">
            <label htmlFor="manual-free" className="text-sm font-extrabold" data-id="element-339" data-mp="2xltjt3pkffwn">
              Opis
            </label>
            <input id="manual-free" value={freeLabel} onChange={e => setFreeLabel(e.target.value)} placeholder="npr. Kitara za zabavo" className={inputCls} data-id="element-340" data-mp="2jl0mycbsk8qd" />
            <p className="mt-1 text-xs text-muted" data-id="element-341" data-mp="188zryfoc3o26">Prosta dejavnost ne prinese točk in ne ustvari obveznosti.</p>
          </div>}
        <div className="grid grid-cols-2 gap-3" data-id="element-342" data-mp="14nwlfjdjpksr">
          <div data-id="element-343" data-mp="14qsk59x7wdi9">
            <label htmlFor="manual-minutes" className="text-sm font-extrabold" data-id="element-344" data-mp="zpmp35g34e5k">
              Minute
            </label>
            <input id="manual-minutes" type="number" inputMode="numeric" min={1} max={600} value={minutesText} onChange={e => setMinutesText(e.target.value)} className={inputCls} data-id="element-345" data-mp="1enf3tvdt4yip" />
          </div>
          <div data-id="element-346" data-mp="h06fztqc3ddj">
            <label htmlFor="manual-date" className="text-sm font-extrabold" data-id="element-347" data-mp="h0oiv97i4puf">
              Datum
            </label>
            <input id="manual-date" type="date" value={date} onChange={e => setDate(e.target.value)} className={inputCls} data-id="element-348" data-mp="vq47aijk8j6y" />
          </div>
        </div>
        {minutesText !== '' && !minutesValid && <p className="text-xs font-semibold text-accent-ink" data-id="element-349" data-mp="35dory1308r4">Vpiši od 1 do 600 minut.</p>}
        <p className="text-xs text-muted" data-id="element-350" data-mp="3uc70hvti3q9w">
          Vnos v dnevnik časa naloge ne obkljuka. Obkljukaš jo posebej – brez časovnika je to vedno mogoče.
        </p>
      </form>
    </Sheet>;
}